import { render, staticRenderFns } from "./_control-area.vue?vue&type=template&id=447ebdb0&scoped=true"
import script from "./_control-area.vue?vue&type=script&lang=js"
export * from "./_control-area.vue?vue&type=script&lang=js"
import style0 from "./_control-area.vue?vue&type=style&index=0&id=447ebdb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ebdb0",
  null
  
)

export default component.exports